import React                   from 'react'
import { connect }             from 'react-redux'
import {mapDispatchToProps} from "../mapDispatchToProps"
import Terms from './terms/Terms'

class TermsOfUse extends (React.Component) {
  render() {
    return (
      <Terms />
    )
  }
}

function mapStateToProps(state) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TermsOfUse)
